import React from 'react';
import { HomeIco } from './icons/HomeIco';
import { FolderIco } from './icons/FolderIco';
import { EmailDocIco } from './icons/EmailDocIco';
import { QuestionIcoWithCounter } from './icons/QuestionIcoWithCounter';
import { NewsIco } from './icons/NewsIco';
import { EmailTemplateIco } from './icons/EmailTemplateIco';
import { SettingsIco } from './icons/SettingsIco';
import { PublishNewsIco } from './icons/PublishNewsIco';
import { StarIco } from './icons/StarIco';
import { EventsIco } from './icons/EventsIco';
import { APP_ROUTES } from '../../../routing/AppRoutes';

export interface IUserMenuItem {
  label: string | React.ElementType;
  path: string;
  ico: any;
  basePath?: string;
}

export const journalistMenuItems: Array<IUserMenuItem> = [
  {
    label: 'Dashboard',
    path: APP_ROUTES.JOURNALIST_DASHBOARD,
    ico: HomeIco,
  },
  {
    label: 'Directory',
    path: APP_ROUTES.ALL_CONTACTS,
    basePath: APP_ROUTES.DIRECTORY,
    ico: FolderIco,
  },
  {
    label: 'Interviews',
    path: APP_ROUTES.JOURNALIST_ALL_INTERVIEWS,
    basePath: '/interviews',
    ico: EmailDocIco,
  },
  {
    label: 'Questions',
    path: APP_ROUTES.JOURNALIST_QUESTIONS,
    ico: QuestionIcoWithCounter,
  },
  {
    label: 'Email templates',
    path: APP_ROUTES.EMAIL_TEMPLATES_ALL,
    ico: EmailTemplateIco,
    basePath: APP_ROUTES.EMAIL_TEMPLATES,
  },
  {
    label: 'Profile',
    path: APP_ROUTES.JOURNALIST_PERSONAL_INFO,
    basePath: APP_ROUTES.JOURNALIST_PROFILE,
    ico: SettingsIco,
  },
];

export const managerMenuItems: Array<IUserMenuItem> = [
  {
    label: 'Questions',
    path: APP_ROUTES.EXPERT_QUESTIONS,
    ico: QuestionIcoWithCounter,
  },
  {
    label: 'Interview invitations',
    path: APP_ROUTES.EXPERT_PENDING_INTERVIEWS,
    basePath: '/interviews',
    ico: EmailDocIco,
  },
  {
    label: 'Guests',
    path: APP_ROUTES.GUESTS,
    ico: StarIco,
  },
  {
    label: 'Profile',
    path: APP_ROUTES.EXPERT_PERSONAL_INFO,
    basePath: APP_ROUTES.EXPERT_PROFILE,
    ico: SettingsIco,
  },
  {
    label: 'Publish news',
    path: APP_ROUTES.CONTACTS_MANAGER,
    ico: PublishNewsIco,
  },
  {
    label: 'Background Briefing',
    path: APP_ROUTES.EVENTS_LIST,
    ico: EventsIco,
  },
];
